import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_API_URL || '';

export const viewResume = (urlOrKey) => {
  if (!urlOrKey) return;

  let finalUrl = urlOrKey;

  // If only S3 key stored
  if (!urlOrKey.startsWith('http')) {
    const bucket = process.env.REACT_APP_S3_BUCKET || "exihire-files";
    const region = process.env.REACT_APP_AWS_REGION || "ap-south-1";

    finalUrl = `https://s3.${region}.amazonaws.com/${bucket}/${urlOrKey}`;
  }

  window.open(finalUrl, "_blank");
};
